module.exports = __webpack_public_path__ + "img/APC@3x@2x.e496ba44.png";